import HttpUtils from '../utils/HttpUtils'

//注册
const register = (data: {
  phone: string,
  nickName: string,
  password: string,
  code: string
}) => {
  return HttpUtils.post("/qzkt/user/register", data)
}

//忘记密码
const forgetPwd = (data: {
  phone: string,
  password: string,
  code: string
}) => {
  return HttpUtils.post("/qzkt/user/resetPassword", data)
}

// 发送验证码，废弃，请使用sendSmsV1
const sendPhoneCode = (phone: string) => {
  return HttpUtils.post("/qzkt/user/phoneMsg/send?phone=" + phone)
}

// 登录
const login = (data: {
  phone: string,
  password: string
}) => {
  return HttpUtils.post("/qzkt/user/login", data)
}
// 短信直接登录
const loginBySms = (data: {
  phone: string,
  code: string
}) => {
  return HttpUtils.post("/qzkt/user/loginBySms", data)
}

// openid绑定手机号
const wxOpenIdBindPhoneHandle = (data: {
  phone: string,
  code: string,
  wxOpenid: string
}) => {
  return HttpUtils.post("/qzkt/user/wxOpenIdBindPhone", data)
}


// phone:phoneNum,
// captcha,
// captchaKey: captchaKey.val()
const sendSmsV1 = (data:{
  phone:string,
  captcha:string,
  captchaKey:string
})=>{
  return HttpUtils.post("/qzkt/sms/send/v1", data)
}

//qzkt/sms/captcha
const getSmsCaptcha = ()=>{
  return HttpUtils.get("/qzkt/sms/captcha")
}

const logout = () => {
  ///qzkt/user/quit
  return HttpUtils.post("/qzkt/user/quit")
}

const getWechatLoginQrCode = ()=>{
  return HttpUtils.get("/qzkt/wx/web/login-qrcode-url")
}
// 轮询登录状态
const getWxLoginState = (sceneStr:string) => {
  return HttpUtils.get("/qzkt/wx/web/checkLogin/"+sceneStr)
}



const UserService = {
  register,
  sendPhoneCode,
  login,
  logout,
  forgetPwd,
  loginBySms,
  sendSmsV1,
  getSmsCaptcha,
  getWechatLoginQrCode,
  getWxLoginState,
  wxOpenIdBindPhoneHandle
}

export default UserService;